<template>
  <div ref="fillUpcons" id="fillUpcons">
    <div class="title-name" v-if="hasDivider" > <b v-if="isneed" class="red">*</b>{{label}} &nbsp;<span class="el-upload__tip"> <b class="red" v-if="tips">#</b>{{tips}}</span></div>
    <el-upload v-bind="uploadBinds" :multiple="!limit" list-type="picture-card" >
      <i class="el-icon-plus"></i>
    </el-upload>
    <upload-views ref="uploadViews" @removesList="removesList" :view-lists="fileLists" :textAreas="textAreas"></upload-views>
  </div>
</template>

<script>
  import uploadViews from '../../components/viewFiles/uploadViews'
  import {getToken} from "@/utils/auth";

  export default {
    name: "index",
    components: {uploadViews},
    props: {
      //控制回显的文本框
      hasDivider:{
        type:Boolean,
        default:true
      },
      textAreas:{
      },
      isneed:{
        default: false
      },
      // action: {},
      label: {},
      tips: {},
      url: {
        default:(process.env.VUE_APP_SITE||'')+ '/api_file/upload.do?actionMethod=processWater&&systemHeader=/cms/content/case&&busiType=CASE&&businessId='
      },
      limit: {},
      acc:{}
    },
    data() {
      return {
        fileLists:[]
      }
    },
    computed: {
      uploadBinds() {
        const {$attrs, fileLists, limit, action} = this;
        let _this = this
        // console.log($attrs,this.limit)
        // const bind ={}

        let obj = {
          ['before-upload']: function (res) {
            console.log("filesupload")
            this.$emit('getList',this.fileLists)
            if (fileLists.length == (limit - 1)) {
              let fillUpcons = _this.$refs['fillUpcons']
              let btn = fillUpcons.getElementsByClassName('el-upload--picture-card')[0]
              btn.style.display = 'none'
            }
            if (fileLists.length == limit) {
              this.$message.error('该类型图片上传数量限制' + limit + '张!');
              return false
            }
            return true
          },
          ['on-success']: function (res) {
            console.log("res",res)
              fileLists.push(...res.datas)
            _this.$emit('getList',fileLists)
            console.log(fileLists)
            // if(limit==1){
            //   let  fillUpcons= _this.$refs['fillUpcons']
            //   let btn = fillUpcons.getElementsByClassName('el-upload--picture-card')[0]
            //   btn.style.display='none'
            // }
          },
          action: this.VUE_APP_SITE+this.url + $attrs.action,
          accept: $attrs.accept == 'imgs' ? '.png,.jpg,.jpeg,.bmp,.gif' : $attrs.accept
        }

        //
        // Object.keys($attrs).forEach(key => {
        //   let v = $attrs[key]
        //
        //   //统一植入header
        //   if(key=='headers'){
        //     v={token:getToken()}
        //   }
        //
        //   if(key=='action'){
        //     v=this.url+v
        //   }
        //
        //
        //   if(key=='list-type'){
        //     //强制使用卡片.不再接受参数
        //     v='picture-card'
        //   }
        //
        //   if(key=='on-preview'||key=='on-remove'){
        //     //   不再接受预览和取消函数
        //     v=null
        //   }
        //   //统一处理图片
        //   if(key=='accept'&&v=='imgs'){
        //     v='.png,.jpg,.jpeg,.bmp,.gif'
        //   }
        //   if(key=='on-success'){
        //     console.log(999999)
        //     //用一个参数接受传过来的函数，先运行通用的然后运行额外的
        //     let fn=v
        //     v=(res)=>{
        //       // console.log("res.data.data[0] = ",res.data[0])
        //       console.log(this.fileLists)
        //       // this.fileLists.push(res.data[0])
        //       //判断limit的值，如果是一个，让上传按钮消失不让点了
        //       if(this.limit==1){
        //        let  fillUpcons= this.$refs['fillUpcons']
        //         let btn = fillUpcons.getElementsByClassName('el-upload--picture-card')[0]
        //         btn.style.display='none'
        //       }
        //       if(typeof fn ==='function'){
        //         fn(res)
        //       }
        //
        //     }
        //   }
        //   // const uniformKey = key.replace(/([A-Z])/, '-$1').toLowerCase()
        //   bind[key] =  v
        // })
        // console.log(bind)
        return {...this.$attrs, ...obj}
      }
    },
    methods: {
      getTextAreas(){
        // console.log(this.$refs.uploadViews,this.$refs.uploadViews[0],8888);
        return this.$refs.uploadViews.getTextAreas()
      },
      removesList(v,u) {
        this.fileLists = v
        if (this.fileLists.length == (this.limit - 1)) {
          let fillUpcons = this.$refs['fillUpcons']
          let btn = fillUpcons.getElementsByClassName('el-upload--picture-card')[0]
          btn.style.display = 'block'
        }
        this.$emit('getList',this.fileLists,u)
        //this.$emit('getList',this.fileLists)
      }
    },
    watch:{
      // 'action':function () {
      //
      // }
      async fileLists(newVal, oldVal){
        let falg = false
        if (newVal.length > 0) {
          falg = true;
        }
        this.$emit("changeHasUpload",falg)
      },
      async ['$attrs.action'](o,n){
        let fileLists = await  this.$fetchData(
          this.$api.imageFile.getImages + "&businessIds="  + o
        )
        this.fileLists=fileLists&&fileLists.data||[];
        console.log(this.limit,this.fileLists)
        if(this.limit == this.fileLists.length){
          let  fillUpcons= this.$refs['fillUpcons']
          let btn = fillUpcons.getElementsByClassName('el-upload--picture-card')[0]
          btn.style.display='none'
        }
      }
    },
    async mounted() {
      const {$attrs} = this;
      let fileLists = await  this.$fetchData(
        this.$api.imageFile.getImages + "&businessIds=" + $attrs.action
      )
      this.fileLists = fileLists && fileLists.data || [];
      this.$emit('getList',fileLists.data)
      if (this.limit == this.fileLists.length) {
        let fillUpcons = this.$refs['fillUpcons']
        let btn = fillUpcons.getElementsByClassName('el-upload--picture-card')[0]
        btn.style.display = 'none'
      }
    }
  }
</script>

<style>
  #fillUpcons .el-upload-list.el-upload-list--picture-card {
    display: none;
  }

  .el-upload__tip {
    font-weight: normal;
  }

  .el-upload__tip .red {
    color: red;
  }
</style>
